export default class CoinPrice {
    constructor(element) {
        this.el = element;
        this.initBuyButton();
    }

    initBuyButton() {
        const btn = this.el.querySelector('[data-coin-price-buy]');

        if (!btn) {
            return;
        }

        btn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
}
